module.exports = __webpack_public_path__ + "img/payroll_processing.e77ea8e9.png";